import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-x",
  "use": "rt-portal-x-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-x\">\r\n<path d=\"M564.3,512l262.8-312.9c4.4-5.2,0.7-13.1-6.1-13.1h-79.9c-4.7,0-9.2,2.1-12.3,5.7L512,449.8L295.3,191.7\r\n\tc-3-3.6-7.5-5.7-12.3-5.7h-79.9c-6.8,0-10.5,7.9-6.1,13.1L459.8,512L196.9,824.9c-4.4,5.2-0.7,13.1,6.1,13.1h79.9\r\n\tc4.7,0,9.2-2.1,12.3-5.7L512,574.2l216.8,258.1c3,3.6,7.5,5.7,12.3,5.7H821c6.8,0,10.5-7.9,6.1-13.1L564.3,512z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/x.svg
// module id = 1354
// module chunks = 91